<template>
  <Layout>
    <b-modal
        id="modalPartidasModificaciones"
        scrollable
        title="Partidas Modificaciones"
        title-class="font-18"
        size="xl"
        no-close-on-esc
        centered
        @ok="handleOkPartidasModificaciones"
    >
      <b-overlay :show="isLoadingModal" >
        <div class="row">
          <div class="col-md-2">
            <input class="form-control" type="text" v-model="filter">
          </div>
        </div>

        <table class="table table-striped">
          <thead>
          <tr>
            <th>Codigo partida</th>
            <th>Partida</th>
            <th>UM</th>
            <th>Metrado</th>
            <th>C.U.</th>
            <th>Parcial</th>
            <th>Fecha</th>
            <th>Observaciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, index) in filteredRows" :key="index">
            <td>{{row.codigo_partida}}</td>
            <td>{{row.partida}}</td>
            <td>{{row.unidad_medida}}</td>
            <td>{{row.cantidad}}</td>
            <td>{{row.costo_unitario}}</td>
            <td>{{row.subtotal}}</td>
            <td>{{row.fecha}}</td>
            <td>{{row.observaciones}}</td>
          </tr>
          </tbody>
        </table>
      </b-overlay>
    </b-modal>
    <b-modal
        id="modalUploadPartidasModificaciones"
        scrollable
        title="Subir archivo"
        title-class="font-18"
        size="lg"
        no-close-on-esc
        hide-footer
        centered
    >
      <subirArchivos v-on:upload-complete="uploadCompleteModificaciones" />
    </b-modal>

    <b-modal
        id="modalUploadPresupuestoModificado"
        scrollable
        title="Subir archivo"
        title-class="font-18"
        size="lg"
        no-close-on-esc
        hide-footer
        centered
    >
      <subirArchivos v-on:upload-complete="uploadCompletePresupuestoModificado" />
    </b-modal>
    <b-modal
        id="modalNuevasPartidas"
        title="Agregar partida"
        title-class="font-18"
        size="xl"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
    >
      <b-overlay :show="isLoadingModal">
        <form class="needs-validation" @submit.prevent="agregarNuevaPartidaSubmit">
          <div class="form-row">
            <div class="form-group col-md-2">
              <label>Tipo</label>
              <select class="form-control" v-model="nueva_partida.tipo" @change="cambiarTipo($event)">
                <option value = "P">Partida</option>
                <option value = "T">Titulo</option>
              </select>
            </div>
            <div class="form-group col-md-2">
              <label>Tipo</label>
              <select class="form-control" v-model="nueva_partida.tipo_costo" @change="cambiarTipo($event)" >
                <option value = "Costo directo">Costo directo</option>
                <option value = "Costo indirecto">Costo indirecto</option>
              </select>
            </div>
            <div class="form-group col-md-2">
              <label>Codigo de partida </label>
              <input
                  class="form-control" v-model="nueva_partida.codigo_partida"
                  :class="{ 'is-invalid': submittedNuevaPartida && $v.nueva_partida.codigo_partida.$error }"
                  placeholder="00.00.00.00"
              />
              <div v-if="submittedNuevaPartida && $v.nueva_partida.codigo_partida.$error" class="invalid-feedback">
                <span v-if="!$v.nueva_partida.codigo_partida.required">Este valor es requerido.</span>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label>Nombre de la partida</label>
              <input
                  class="form-control" v-model="nueva_partida.partida"
                  :class="{ 'is-invalid': submittedNuevaPartida && $v.nueva_partida.partida.$error }"
              />
              <div v-if="submittedNuevaPartida && $v.nueva_partida.partida.$error" class="invalid-feedback">
                <span v-if="!$v.nueva_partida.partida.required">Este valor es requerido.</span>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-2"   v-show="nueva_partida.tipo=='P'">
              <label>Unidad de medida</label>
              <input
                  class="form-control" v-model="nueva_partida.unidad_medida"
                  :class="{ 'is-invalid': submittedNuevaPartida && $v.nueva_partida.unidad_medida.$error }"
                  :disabled="disable_nueva_partida_um"
              />
              <div v-if="submittedNuevaPartida && $v.nueva_partida.unidad_medida.$error" class="invalid-feedback">
                <span v-if="!$v.nueva_partida.unidad_medida.required">Este valor es requerido.</span>
               </div>
            </div>

            <div class="form-group col-md-2"  v-show="nueva_partida.tipo=='P'">
              <label>Cantidad</label>
              <input
                  class="form-control" v-model="nueva_partida.cantidad"
                  :class="{ 'is-invalid': submittedNuevaPartida && $v.nueva_partida.cantidad.$error }"
                  :disabled="disable_nueva_partida_cantidad"
                  @input="calcularSubtotal()"
              />
              <div v-if="submittedNuevaPartida && $v.nueva_partida.cantidad.$error" class="invalid-feedback">
                <span v-if="!$v.nueva_partida.cantidad.required">Este valor es requerido.</span>
                <span v-if="!$v.nueva_partida.cantidad.decimal">Solos se adminte numeros.</span>
              </div>
            </div>
            <div class="form-group col-md-2"  v-show="nueva_partida.tipo=='P'">
              <label>C. U.</label>
              <input
                  class="form-control" v-model="nueva_partida.costo_unitario"
                  :class="{ 'is-invalid': submittedNuevaPartida && $v.nueva_partida.costo_unitario.$error }"
                  :disabled="disable_nueva_partida_costo_unitario"
                  @input="calcularSubtotal()"
              />
              <div v-if="submittedNuevaPartida && $v.nueva_partida.costo_unitario.$error" class="invalid-feedback">
                <span v-if="!$v.nueva_partida.costo_unitario.required">Este valor es requerido.</span>
                <span v-if="!$v.nueva_partida.costo_unitario.decimal">Solos se adminte numeros.</span>
              </div>
            </div>
            <div class="form-group col-md-2"  v-show="nueva_partida.tipo=='P'">
              <label>Subtotal</label>
              <input
                  class="form-control" v-model="nueva_partida.subtotal"
                  :class="{ 'is-invalid': submittedNuevaPartida && $v.nueva_partida.subtotal.$error }"
                  :disabled="disable_nueva_partida_subtotal"
              />
              <div v-if="submittedNuevaPartida && $v.nueva_partida.subtotal.$error" class="invalid-feedback">
                <span v-if="!$v.nueva_partida.subtotal.required">Este valor es requerido.</span>
                <span v-if="!$v.nueva_partida.subtotal.decimal">Solos se adminte numeros.</span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label>Fecha</label>
              <VueCtkDateTimePicker
                  v-model="nueva_partida.fecha"
                  :locale="'es'"
                  :input-size="'sm'"
                  :format="'YYYY-MM-DD'"
                  :formatted="'YYYY-MM-DD'"
                  :range="false"
                  :auto-close="true"
                  :only-date="true"
                  :no-header="true"
                  style="z-index: 100"
                  :class="{ 'is-invalid': submittedNuevaPartida && $v.nueva_partida.fecha.$error }"
              />
              <div v-if="submittedNuevaPartida && $v.nueva_partida.fecha.$error" class="invalid-feedback">
                <span v-if="!$v.nueva_partida.fecha.required">Este valor es requerido.</span>
              </div>
            </div>

          </div>
          <div class="form-row">
            <div class="col-md-12 text-right">
              <button type="submit" v-show="$can('avance-modificaciones-agregar')"
                      class="btn btn-primary mt-4"><i class="fa fa-save"></i> Guardar
              </button>

            </div>

          </div>
        </form>
      </b-overlay>
    </b-modal>
    <b-modal
        id="modalPartidas"
        title="Modificación de valorizaciones"
        title-class="font-18"
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
    >
      <b-overlay :show="isLoadingModal">
        <h3>{{titulo_modal}}</h3>
        <form class="needs-validation" @submit.prevent="agregarModificarPartidaSubmit">
          <div class="form-row">
            <div class="form-group col-md-12" style="z-index: 10"
                 v-if="parseInt(partida_modificar.tipo_modificacion)!=5 && partida_modificar.id==0">
              <label>Partida</label>
              <v-select
                  :options="partidas"
                  label="descripcion"
                  v-model="partida"
              />
            </div>
            <div class="form-group col-md-12" style="z-index: 10"
                 v-if="parseInt(partida_modificar.tipo_modificacion)==5 && partida_modificar.id==0">
              <label>Partida</label>
              <v-select
                  :options="partidas_nuevas"
                  label="descripcion"
                  v-model="partida"
              />
            </div>
            <div class="form-group col-md-12" style="z-index: 10"
                 v-if="partida_modificar.id!=0">
              <label>Partida</label>
              <p><strong>{{partida_modificar.partida}}</strong></p>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-3"  >
              <label>Cantidad</label>
              <input
                  class="form-control" v-model="partida_modificar.cantidad"
                  :class="{ 'is-invalid': submittedModificarPartida && $v.partida_modificar.cantidad.$error }"
                  :disabled="disable_modificar_partida_cantidad"
                  @input="calcularSubtotalPartidaModificada()"
              />
              <div v-if="submittedModificarPartida && $v.partida_modificar.cantidad.$error" class="invalid-feedback">
                <span v-if="!$v.partida_modificar.cantidad.required">Este valor es requerido.</span>
                <span v-if="!$v.partida_modificar.cantidad.decimal">Solos se adminte numeros.</span>
              </div>
            </div>

            <div class="form-group col-md-3" >
              <label>C. U.</label>
              <input
                  class="form-control" v-model="partida_modificar.costo_unitario"
                  :class="{ 'is-invalid': submittedModificarPartida && $v.partida_modificar.costo_unitario.$error }"
                  :disabled="disable_modificar_partida_costo_unitario"
                  @input="calcularSubtotalPartidaModificada()"
              />
              <div v-if="submittedModificarPartida && $v.partida_modificar.costo_unitario.$error" class="invalid-feedback">
                <span v-if="!$v.partida_modificar.costo_unitario.required">Este valor es requerido.</span>
                <span v-if="!$v.partida_modificar.costo_unitario.decimal">Solos se adminte numeros.</span>
              </div>
            </div>

            <div class="form-group col-md-3" >
              <label>Subtotal</label>
              <input
                  class="form-control" v-model="partida_modificar.subtotal"
                  :class="{ 'is-invalid': submittedModificarPartida && $v.partida_modificar.subtotal.$error }"
                  :disabled="disable_modificar_partida_subtotal"
              />
              <div v-if="submittedModificarPartida && $v.partida_modificar.subtotal.$error" class="invalid-feedback">
                <span v-if="!$v.partida_modificar.subtotal.required">Este valor es requerido.</span>
                <span v-if="!$v.partida_modificar.subtotal.decimal">Solos se adminte numeros.</span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label>Fecha</label>
              <VueCtkDateTimePicker
                  v-model="partida_modificar.fecha"
                  :locale="'es'"
                  :input-size="'sm'"
                  :format="'YYYY-MM-DD'"
                  :formatted="'YYYY-MM-DD'"
                  :range="false"
                  :auto-close="true"
                  :only-date="true"
                  :no-header="true"
                  style="position: fixed;width: 180px"
                  :class="{ 'is-invalid': submittedModificarPartida && $v.partida_modificar.fecha.$error }"
              />
              <div v-if="submittedModificarPartida && $v.partida_modificar.fecha.$error" class="invalid-feedback">
                <span v-if="!$v.partida_modificar.fecha.required">Este valor es requerido.</span>
              </div>
            </div>
          </div>
          <div class="form-row">
            <button type="submit" v-show="$can('avance-modificaciones-agregar')"
                    class="btn btn-primary mt-4"><i class="fa fa-save"></i> Guardar
            </button>
          </div>
        </form>
      </b-overlay>
    </b-modal>
    <PageHeader :title="title" :items="items" />
      <b-card class="border-11">
        <b-overlay :show="isLoading">
          <div class="form-row">
            <div class="form-group col-md-8">
              <label>Expediente</label>
              <v-select
                  :options="expedientes"
                  label="obra_expediente"
                  :reduce="desc=>desc.expediente_id"
                  v-model="expediente_id"
                  @input="actualizar()"
              />
            </div>
            <div class="form-group col-md-4" >
              <label>Mes</label>
              <month-picker-input
                  @change="cambiarMes"
                  style="z-index:1"
                  :default-month="mes_actual"
              ></month-picker-input>
            </div>
          </div>


          <hr>
          <b-tabs card>
            <b-tab title="Def. nuevas partidas" active>

              <div class="row mt-4">
                <div class="col-md-6">
                  <button type="button" v-show="$can('avance-modificaciones-agregar')"
                          v-on:click="agregarNuevasPartidasForm"
                          class="btn btn-primary mr-2"><i class="fa fa-plus"></i> Agregar
                  </button>
                  <button type="button" :disabled="!$can('avance-modificaciones-importar')"
                          v-on:click="abrirCargaModificaciones(1)"
                          class="btn btn-secondary"><i class="fa fa-upload"></i> Importar ...
                  </button>
                  <b-dropdown id="dropdown-1" text="Opciones ..." class="m-md-2"  v-show="$can('avance-modificaciones-modificar')">
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item v-on:click="borrarTodasLasPartidas(1)">Borrar todo</b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="col-md-6">
                  <h5> Definición Partidas nuevas: S/ {{registros.definicion_nuevas_partidas_suma}}</h5>
                </div>
                <!--</div>-->
              </div>
              <hr>
              <div class="row">
                <table class="table table-bordered table-striped table-condensed">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>Tipo</th>
                    <th>Tipo costo</th>
                    <th>Codigo</th>
                    <th>Partida</th>
                    <th>UdM</th>
                    <th>Cantidad</th>
                    <th>C.U.</th>
                    <th>Subtotal</th>
                    <th style="width: 100px">OP</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!--<tr v-for="(data,index) in filtroGlobal(1)"  v-bind:key="index">-->
                  <tr v-for="(data,index) in registros.definicion_nuevas_partidas"  v-bind:key="index">
                    <td> {{data.id}}</td>
                    <td>{{data.fecha}}</td>
                    <td>{{ (data.tipo === "T") ? "Título" : "Partida" }}</td>
                    <td>{{data.tipo_costo}}</td>
                    <td> {{data.codigo_partida}}</td>
                    <td> {{data.partida}} </td>
                    <td> {{data.unidad_medida}} </td>
                    <td> {{data.cantidad}}</td>
                    <td> {{data.costo_unitario}} </td>
                    <td> {{data.subtotal}}</td>
                    <td>
                      <button  v-if="$can('avance-modificaciones-modificar')" class="btn btn-primary btn-icon btn-sm"
                               v-on:click="editarPartidaNueva(data.id)"
                      ><i class="fa fa-edit"></i></button>
                      <button v-if="$can('avance-modificaciones-eliminar')"
                              class="btn btn-danger btn-icon btn-sm ml-1"
                              v-on:click="borrarPartida(data.id)" ><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab title="Avance nuevas partidas">
              <div class="row mt-4">
                <div class="col-md-6">
                  <button type="button" v-show="$can('avance-modificaciones-agregar')"
                          v-on:click="agregarValorizacionNuevasPartidasForm"
                          class="btn btn-primary"
                  >
                    <i class="fa fa-plus"></i> Agregar
                  </button>
                  <b-dropdown id="dropdown-1" text="Opciones ..." class="m-md-2"  v-show="$can('avance-modificaciones-modificar')">
                    <b-dropdown-item v-on:click="actualizarCostos(5)" >Actualizar Costos unitarios</b-dropdown-item>
                    <b-dropdown-item v-on:click="copiarDeDefinicion(5)" >Copiar de definición de partidas </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item v-on:click="borrarTodasLasPartidas(5)">Borrar todo</b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="col-md-6">
                  <h5> Avance Partidas nuevas: S/ {{registros.valorizacion_nuevas_partidas_suma}}</h5>
                </div>

                <!--<div class="form-group col-md-2">-->

              </div>
              <hr>
              <div class="row">
                <table class="table table-bordered table-striped table-condensed">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>Tipo costo</th>
                    <th>Codigo</th>
                    <th>Partida</th>
                    <th>UdM</th>
                    <th>Cantidad</th>
                    <th>C.U.</th>
                    <th>Subtotal</th>
                    <th style="width: 90px">OP</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!--<tr v-for="(data,index) in filtroGlobal(5)"  v-bind:key="index">-->
                  <tr v-for="(data,index) in registros.valorizacion_nuevas_partidas"  v-bind:key="index">
                    <td> {{data.id}}</td>
                    <td>{{data.fecha}}</td>
                    <td>{{data.tipo_costo}}</td>
                    <td> {{data.codigo_partida}}</td>
                    <td> {{data.partida}} </td>
                    <td>{{data.unidad_medida}}</td>
                    <td> {{data.cantidad}}</td>
                    <td> {{data.costo_unitario}}</td>
                    <td> {{data.subtotal}}</td>
                    <td>
                      <button  v-if="$can('avance-modificaciones-modificar')" class="btn btn-primary btn-icon btn-sm"
                               v-on:click="editarModificacionPartida(data.id)"
                      ><i class="fa fa-edit"></i></button>
                      <button v-if="$can('avance-modificaciones-eliminar')" class="btn btn-danger btn-icon btn-sm ml-1" v-on:click="borrarPartida(data.id)" ><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab title="Def. mayores metrados">
              <div class="row text-danger"  >
                <p>Solo se debe llenar cuando ya se tenga el expediente tecnico modificado y/o cuando se tenga el metrado total. </p>
              </div>
              <div class="row mt-4">
                <div class="col-md-6">
                  <button type="button" v-show="$can('avance-modificaciones-agregar')"
                          v-on:click="definicionMayoresMetradosForm"
                          class="btn btn-primary"><i class="fa fa-plus"></i> Agregar
                  </button>
                  <button type="button" :disabled="!$can('avance-modificaciones-importar')"
                          v-on:click="abrirCargaModificaciones(3)"
                          class="btn btn-secondary ml-2"><i class="fa fa-upload"></i> Importar ...
                  </button>
                  <b-dropdown id="dropdown-1" text="Opciones ..." class="m-md-2"  v-show="$can('avance-modificaciones-modificar')">
                    <b-dropdown-item v-on:click="alert('EN IMPLEMENTACIÓN')">Calcular a partir de mayores metrados</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item v-on:click="borrarTodasLasPartidas(3)">Borrar todo</b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="col-md-6">
                  <h5> Definición mayores metrados: S/ {{registros.definicion_mayores_metrados_suma}}</h5>
                </div>
              </div>
              <hr>
              <div class="row">
                <table class="table table-bordered table-striped table-condensed">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>Tipo costo</th>
                    <th>Codigo</th>
                    <th>Partida</th>
                    <th>UdM</th>
                    <th>Cantidad</th>
                    <th>C.U.</th>
                    <th>Subtotal</th>
                    <th style="width: 90px">OP</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!--<tr v-for="(data,index) in filtroGlobal(3)"  v-bind:key="index">-->
                  <tr v-for="(data,index) in registros.definicion_mayores_metrados"  v-bind:key="index">
                    <td> {{data.id}}</td>
                    <td>{{data.fecha}}</td>
                    <td>{{data.tipo_costo}}</td>
                    <td> {{data.codigo_partida}}</td>
                    <td> {{data.partida}} </td>
                    <td>{{data.unidad_medida}}</td>
                    <td> {{data.cantidad}}</td>
                    <td> {{data.costo_unitario}}</td>
                    <td> {{data.subtotal}}</td>
                    <td>
                      <button  v-if="$can('avance-modificaciones-modificar')" class="btn btn-primary btn-icon btn-sm"
                               v-on:click="editarModificacionPartida(data.id)"
                      ><i class="fa fa-edit"></i></button>
                      <button v-if="$can('avance-modificaciones-eliminar')" class="btn btn-danger btn-icon btn-sm ml-1" v-on:click="borrarPartida(data.id)" ><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab title="Avance mayores metrados">
              <div class="row mt-4">
                <div class="col-md-6 ">
                  <button type="button" v-show="$can('avance-modificaciones-agregar')"
                          v-on:click="agregarMayoresMetradosForm"
                          class="btn btn-primary "><i class="fa fa-plus"></i> Agregar
                  </button>
                  <b-dropdown id="dropdown-1" text="Opciones ..." class="m-md-2"  v-show="$can('avance-modificaciones-modificar')">
                    <b-dropdown-item v-on:click="actualizarCostos(2)" >Actualizar Costos unitarios</b-dropdown-item>
                    <b-dropdown-item v-on:click="copiarDeDefinicion(2)" >Copiar de definición de mayores metrados </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item v-on:click="borrarTodasLasPartidas(2)">Borrar todo</b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="col-md-6">
                  <h5> Avance mayores metrados: S/ {{registros.avance_mayores_metrados_suma}}</h5>
                </div>
              </div>
              <hr>
              <div class="row">
                <table class="table table-bordered table-striped table-condensed">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>Tipo costo</th>
                    <th>Codigo</th>
                    <th>Partida</th>
                    <th>UdM</th>
                    <th>Cantidad</th>
                    <th>C.U.</th>
                    <th>Subtotal</th>
                    <th style="width: 90px">OP</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!--<tr v-for="(data,index) in filtroGlobal(2)"  v-bind:key="index">-->
                  <tr v-for="(data,index) in registros.avance_mayores_metrados"  v-bind:key="index">
                    <td> {{data.id}}</td>
                    <td>{{data.fecha}}</td>
                    <td>{{data.tipo_costo}}</td>
                    <td> {{data.codigo_partida}}</td>
                    <td> {{data.partida}} </td>
                    <td>{{data.unidad_medida}}</td>
                    <td> {{data.cantidad}}</td>
                    <td> {{data.costo_unitario}}</td>
                    <td> {{data.subtotal}}</td>
                    <td>
                      <button  v-if="$can('avance-modificaciones-modificar')" class="btn btn-primary btn-icon btn-sm"
                               v-on:click="editarModificacionPartida(data.id)"
                      ><i class="fa fa-edit"></i></button>
                      <button v-if="$can('avance-modificaciones-eliminar')" class="btn btn-danger btn-icon btn-sm ml-1" v-on:click="borrarPartida(data.id)" ><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab title="Modificación Costo Unitario">
              <div class="row mt-4">
                <div class="col-md-6">
                  <button type="button" v-show="$can('avance-modificaciones-agregar')"
                          v-on:click="agregarModificacionCostoUnitarioForm"
                          class="btn btn-primary mr-2"><i class="fa fa-plus"></i> Agregar
                  </button>
                  <button type="button" :disabled="!$can('avance-modificaciones-importar')"
                          v-on:click="abrirCargaModificaciones(6)"
                          class="btn btn-secondary"><i class="fa fa-upload"></i> Importar ...
                  </button>
                  <b-dropdown id="dropdown-1" text="Opciones ..." class="m-md-2"  v-show="$can('avance-modificaciones-modificar')">
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item v-on:click="borrarTodasLasPartidas(6)">Borrar todo</b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="col-md-6">
                  <!--<h5> Avance mayores metrados: S/ {{registros.avance_mayores_metrados_suma}}</h5>-->
                </div>
                <!--</div>-->
              </div>
              <hr>
              <div class="row">
                <table class="table table-bordered table-striped table-condensed">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>Tipo costo</th>
                    <th>Codigo</th>
                    <th>Partida</th>
                    <th>UdM</th>
                    <th>Cantidad</th>
                    <th>C.U.</th>
                    <th>Subtotal</th>
                    <th style="width: 90px">OP</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!--<tr v-for="(data,index) in filtroGlobal(6)"  v-bind:key="index">-->
                  <tr v-for="(data,index) in registros.modificacion_costo_unitario"  v-bind:key="index">
                    <td> {{data.id}}</td>
                    <td>{{data.fecha}}</td>
                    <td>{{data.tipo_costo}}</td>
                    <td> {{data.codigo_partida}}</td>
                    <td> {{data.partida}} </td>
                    <td>{{data.unidad_medida}}</td>
                    <td> {{data.cantidad}}</td>
                    <td> {{data.costo_unitario}}</td>
                    <td> {{data.subtotal}}</td>
                    <td>
                      <button  v-if="$can('avance-modificaciones-modificar')" class="btn btn-primary btn-icon btn-sm"
                               v-on:click="editarModificacionPartida(data.id)"
                      ><i class="fa fa-edit"></i></button>
                      <button v-if="$can('avance-modificaciones-eliminar')" class="btn btn-danger btn-icon btn-sm ml-1" v-on:click="borrarPartida(data.id)" ><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab title="Deductivos">
              <div class="row mt-4">
                <div class="col-md-6">
                  <button type="button" v-show="$can('avance-modificaciones-agregar')"
                          v-on:click="agregarDeductivosForm"
                          class="btn btn-primary mr-2"><i class="fa fa-plus"></i> Agregar
                  </button>
                  <button type="button" :disabled="!$can('avance-modificaciones-importar')"
                          v-on:click="abrirCargaModificaciones(4)"
                          class="btn btn-secondary"><i class="fa fa-upload"></i> Importar ...
                  </button>
                  <b-dropdown id="dropdown-1" text="Opciones ..." class="m-md-2"  v-show="$can('avance-modificaciones-modificar')">
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item v-on:click="borrarTodasLasPartidas(4)">Borrar todo</b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="col-md-6">
                  <h5> Deductivos: S/ {{registros.deductivos_suma}}</h5>
                </div>
                <!--</div>-->
              </div>
              <hr>
              <div class="row">
                <table class="table table-bordered table-striped table-hover table-condensed">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>Tipo costo</th>
                    <th>Codigo</th>
                    <th>Partida</th>
                    <th>UdM</th>
                    <th>Cantidad</th>
                    <th>C.U.</th>
                    <th>Subtotal</th>
                    <th style="width: 90px">OP</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!--<tr v-for="(data,index) in filtroGlobal(4)"  v-bind:key="index">-->
                  <tr v-for="(data,index) in registros.deductivos"  v-bind:key="index">
                    <td> {{data.id}}</td>
                    <td> {{data.fecha}}</td>
                    <td> {{data.tipo_costo}}</td>
                    <td> {{data.codigo_partida}}</td>
                    <td> {{data.partida}} </td>
                    <td>{{data.unidad_medida}}</td>
                    <td> {{data.cantidad}}</td>
                    <td> {{data.costo_unitario}}</td>
                    <td> {{data.subtotal}}</td>
                    <td>
                      <button  v-if="$can('avance-modificaciones-modificar')" class="btn btn-primary btn-icon btn-sm"
                               v-on:click="editarModificacionPartida(data.id)"
                      ><i class="fa fa-edit"></i></button>
                      <button v-if="$can('avance-modificaciones-eliminar')"
                              class="btn btn-danger btn-icon btn-sm ml-1"
                              v-on:click="borrarPartida(data.id)" ><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab title="E.T. Modificado">
              <div class="row mt-4">
                <div class="col-md-12">
                    <div class="form-group col-md-8">
                      <label>Modificacion</label>
                      <v-select
                          :options="modificaciones"
                          label="descripcion"
                          :reduce="desc=>desc.id"
                          v-model="modificacion_id"
                      />
                    </div>
                </div>
                <div class="col-md-12">

                  <b-dropdown id="dropdown-1" text="Opciones E.T. Importado" class="m-md-2"  v-show="$can('avance-modificaciones-modificar')">
                    <b-dropdown-item v-on:click="abrirCargaModificaciones(10)">Importar presupuesto modificado</b-dropdown-item>
                    <b-dropdown-item v-on:click="abrirCargaPresupuestoModificado">Importar presupuesto modificado vs anterior</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item v-on:click="verETModificado()">Ver E.T. Importado</b-dropdown-item>
                    <b-dropdown-item v-on:click="verETModificadoVSanterior(0)">Ver E.T. Importado vs Anterior</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item v-on:click="verETModificadoVSanterior(1)">Guardar E.T. Importado vs Anterior</b-dropdown-item>
                    <b-dropdown-item v-on:click="borrarTodasLasPartidas(10)">Borrar todo</b-dropdown-item>
                  </b-dropdown>

                  <button type="button" :disabled="!$can('avance-modificaciones-modificar')"
                          v-on:click="calcularETModificado()"
                          class="btn btn-primary mr-2"><i class="fa fa-cog"></i> Calcular por partidas
                  </button>
                  <button type="button" :disabled="!$can('avance-modificaciones-modificar')"
                          v-on:click="calcularETModificadoPorComponentes()"
                          class="btn btn-primary mr-2"><i class="fa fa-cog"></i> Calcular por componentes
                  </button>

                  <button type="button" :disabled="!$can('avance-modificaciones-modificar')"
                          v-on:click="onBtnExport()"
                          class="btn btn-primary mr-2"><i class="fa fa-file-csv"></i> Exportar CSV
                  </button>


                  <!--<b-dropdown id="dropdown-1" text="Opciones ..." class="m-md-2"  v-show="$can('avance-modificaciones-modificar')">
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item v-on:click="borrarTodasLasPartidas(10)">Borrar todo</b-dropdown-item>
                  </b-dropdown>-->
                </div>
                <div class="col-md-6">
                  <!--<h5> E.T. FINAL : S/ {{registros.deductivos_suma}}</h5>-->
                </div>

                <!--</div>-->
              </div>
              <hr>
              <div class="row">
                <ag-grid-vue
                    style="width: 100%; height: 400px"
                    class="ag-theme-balham"
                    :columnDefs="columnDefs"
                    :rowData="rowData"
                    :gridOptions="gridOptions"
                    @grid-ready="onGridReady"
                >
                </ag-grid-vue>
              </div>
            </b-tab>
          </b-tabs>
        </b-overlay>
      </b-card>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { decimal,required} from "vuelidate/lib/validators";
import subirArchivos from "@/components/subir-archivos.vue";
export default {

  page: {
    title: "Modificaciones de expediente técnico",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    subirArchivos,
    Layout,
    PageHeader,
  },
  name: "modificaciones-expediente-tecnico",
  data(){
    return {
      title: "Avance modificaciones",
      items: [
        {
          text: "Valozacion modificaciones",
          href: "/",
        },
        {
          text: "Modificar",
          active: true,
        },
      ],
      isLoading:false,
      model: {
        descripcion:'',
        detalles:[]
      },
      partida_modificar:{
        costo_unitario:'',
        cantidad:'',
        subtotal:'',
        tipo_modificacion:0,
        fecha:''
      },
      nueva_partida:{
        tipo:'P',
        tipo_costo:'Costo directo',
        codigo_partida:'',
        partida:'',
        unidad_medida:'',
        costo_unitario:'',
        cantidad:'',
        subtotal:'',
        fecha:''
      },
      expedientes:[],
      expediente_id:null,
      submittedNuevaPartida: false,
      partidas:[],
      partidas_nuevas:[],
      partida:null,

      disable_nueva_partida_um:false,
      disable_nueva_partida_cantidad:false,
      disable_nueva_partida_costo_unitario:false,
      disable_nueva_partida_subtotal:false,

      ///

      submittedModificarPartida:false,

      disable_modificar_partida_cantidad:false,
      disable_modificar_partida_costo_unitario:false,
      disable_modificar_partida_subtotal:false,

      isLoadingModal:false,
      fecha_mes:{
        mes:0,
        anio:0
      },
      registros:[],
      mes_actual:this.$mesActual(),
      titulo_modal:"",

      tipo_modificacion_actual:0,
      partidas_modificar:[],
      registros_et_modificado:{
        partidas:[],
        totales:{}
      },
      /////////////
      gridApi: null,
      columnApi: null,
      columnDefs:[],
      rowData:[],
      gridOptions: {
        //floatingFiltersHeight:50,
        defaultColDef: {
          sortable: true,
          resizable: true,
          floatingFilter:true
        },

      },
      filter:"",
      //
      modificacion_id:null,
      modificaciones:[],
      ///
    }
  },
  watch:{

    partida:function (val){
      if(val.tipo_costo=="Costo directo"){
        this.partida_modificar.cantidad=0;
        this.partida_modificar.costo_unitario=val.costo_unitario;
        this.partida_modificar.subtotal=0;
        this.calcularSubtotalPartidaModificada();
      }
      else
      {
        this.partida_modificar.cantidad=0;
        this.partida_modificar.costo_unitario=0;
        this.partida_modificar.subtotal=0;
      }
     this.actualizarControles(val.tipo_costo,val.costo_unitario);
    }
  },
  computed:{
    filteredRows() {
      return this.partidas_modificar.filter(row => {
        const observaciones = row.observaciones.toString().toLowerCase();
        const partida = row.partida.toLowerCase();
        const searchTerm = this.filter.toLowerCase();

        return observaciones.includes(searchTerm) ||
            partida.includes(searchTerm);
      });
    }
  },
  methods:
      {
        verETModificadoVSanterior(sw_modificar){
          if(this.expediente_id ==null){
            this.$swal('Cuidado!',"Selecciona un expediente",'warning')
            return;
          }
          if(this.modificacion_id ==null){
            this.$swal('Cuidado!',"Selecciona una modificacion",'warning')
            return;
          }
          this.isLoading=true;
          this.axios.get(process.env.VUE_APP_BACKEND + '/api/avance/modificaciones/presupuesto-modificado-vs-anterior',{
            params:{
              expediente_id:this.expediente_id,
              sw_modificar:sw_modificar,
              modificacion_id:this.modificacion_id
            }
          })
              .then( (response)=>
              {
                this.columnDefs=response.data.columnas;
                this.rowData=response.data.datos;
                this.gridApi.setPinnedBottomRowData([response.data.resultados]);
              })
              .catch(()=>this.isLoading=false)
              .finally(()=>this.isLoading=false);
        },

        verETModificado(){
          if(this.expediente_id ==null){
            this.$swal('Cuidado!',"Selecciona un expediente",'warning')
            return;
          }
          if(this.modificacion_id ==null){
            this.$swal('Cuidado!',"Selecciona una modificacion",'warning')
            return;
          }
          this.isLoading=true;
          this.axios.get(process.env.VUE_APP_BACKEND + '/api/avance/modificaciones/ver-et-importado',{
            params:{
              expediente_id:this.expediente_id,
              fecha_mes:this.fecha_mes,
              modificacion_id:this.modificacion_id
            }
          })
              .then( (response)=>
              {

                this.columnDefs=response.data.columnas;
                this.rowData=response.data.datos;
                this.gridApi.setPinnedBottomRowData([response.data.resultados]);
              }).finally(()=>this.isLoading=false);
        },
        onBtnExport() {
          this.gridApi.exportDataAsCsv();
        },
        onGridReady(params) {
          this.gridApi = params.api;
          this.gridColumnApi = params.columnApi;
        },
        ////////////
        calcularETModificadoPorComponentes(){
          if(this.expediente_id ==null){
            return;
          }
          this.isLoading=true;
          this.axios.get(process.env.VUE_APP_BACKEND + '/api/avance/modificaciones/calcular-et-modificado-componentes/'+this.expediente_id)
              .then( (response)=>
              {
                //this.registros_et_modificado=response.data;
                this.columnDefs=response.data.columnas;
                this.rowData=response.data.datos;
                this.gridApi.setPinnedBottomRowData([response.data.resultados]);
              }).finally(()=>this.isLoading=false);
        },
        calcularETModificado(){
          if(this.expediente_id ==null){
            return;
          }
          this.isLoading=true;
          this.axios.get(process.env.VUE_APP_BACKEND + '/api/avance/modificaciones/calcular-et-modificado/'+this.expediente_id)
              .then( (response)=>
              {
                //this.registros_et_modificado=response.data;
                this.columnDefs=response.data.columnas;
                this.rowData=response.data.datos;
              }).finally(()=>this.isLoading=false);
        },
        actualizarControles(tipo_costo){
          console.log("actulizando controles");
          if(tipo_costo=="Costo directo"){
            this.disable_modificar_partida_subtotal=true;
            if(this.partida_modificar.tipo_modificacion==6){
              this.disable_modificar_partida_cantidad=true;
            }
            else
            {
              this.disable_modificar_partida_cantidad=false;
            }
            if(this.partida_modificar.tipo_modificacion==2 || this.partida_modificar.tipo_modificacion==5 ||  this.partida_modificar.tipo_modificacion==4 ){
              this.disable_modificar_partida_costo_unitario=true;
            }
            else
            {
              this.disable_modificar_partida_costo_unitario=false;
            }
            this.calcularSubtotalPartidaModificada();
          }
          else
          {
            this.disable_modificar_partida_subtotal=false;
            this.disable_modificar_partida_cantidad=true;
            this.disable_modificar_partida_costo_unitario=true;
          }
        },
        copiarDeDefinicion(modificacion_tipo){
          this.$swal.fire({
            title: '¿Esta seguro de copiar de definición, esto borrará el avance actual de las partidas nuevas?',
            text: "No se puede revertir esta accion!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Si!'
          }).then((result) => {
            if (result.value) {
              this.isLoading=true;
              this.axios.post(process.env.VUE_APP_BACKEND +'/api/avance/modificaciones/copiar-modificaciones-definicion/',{
                expediente_id:this.expediente_id,
                tipo_modificacion:modificacion_tipo
              })
                  .catch((error)=>{
                    this.$swal('error',error.response.data.mensaje,'error');
                  })
                  .finally(
                      ()=>
                      {
                        this.isLoading=false;
                        this.actualizar();
                      }
                  );
            }
          })

        },



        handleOkPartidasModificaciones(bvModalEvent){
          bvModalEvent.preventDefault()
          this.isLoadingModal=true;
          this.axios.post(process.env.VUE_APP_BACKEND + "/api/avance/modificaciones/importar-modificaciones-guardar",
              {
                tipo_modificacion:this.tipo_modificacion_actual,
                expediente_id:this.expediente_id,
                partidas_modificar:this.partidas_modificar
              })
              .then(()=>{
                this.$bvModal.hide("modalUpload");
                this.$bvModal.hide("modalPartidasModificaciones");
                this.actualizar();
              })
              .catch((error)=>{
                if (error.response) {

                  this.$swal('Error',error.response.data.mensaje,'warning');
                }
                else
                {
                  this.$swal('Error',"Server error",'error');
                }
              })
              .finally(()=>{
                this.isLoadingModal=false;
              })

        },
        uploadCompletePresupuestoModificado(files){
          this.isLoading=true;
          this.axios.post(process.env.VUE_APP_BACKEND + "/api/avance/modificaciones/presupuesto-modificado-vs-anterior/archivo",
              {
                file:files,
                expediente_id:this.expediente_id,
                modificacion_id:this.modificacion_id
              })
              .then(()=>{
                this.$bvModal.show("modalUploadPresupuestoModificado");
              })
              .catch((error)=>{
                if (error.response) {
                  console.log(error.response);
                  this.$swal('Error',error.response.data.message,'warning');
                }
                else
                {
                  this.$swal('Error',"Server error",'error');
                }
              })
              .finally(()=>this.isLoading=false)

        },
        uploadCompletePresupuestoModificadoAA(files){
          this.isLoading=true;
          this.axios.post(process.env.VUE_APP_BACKEND + "/api/avance/modificaciones/presupuesto-modificado-vs-anterior",
              {
                file:files,
                expediente_id:this.expediente_id
              })
              .then((response)=>{
                //console.log(response);
                this.partidas_modificar=response.data;
                this.$bvModal.hide("modalUploadPartidasModificaciones");
                this.$bvModal.show("modalPartidasModificaciones");
              })
              .catch((error)=>{
                if (error.response) {
                  console.log(error.response);
                  this.$swal('Error',error.response.data.message,'warning');
                }
                else
                {
                  this.$swal('Error',"Server error",'error');
                }
              })
              .finally(()=>this.isLoading=false)
        },

        uploadCompleteModificaciones(files){
          this.isLoading=true;
          this.axios.post(process.env.VUE_APP_BACKEND + "/api/avance/modificaciones/importar-modificaciones",
              {
                tipo_modificacion:this.tipo_modificacion_actual,
                file:files,
                expediente_id:this.expediente_id
              })
              .then((response)=>{
                //console.log(response);
                this.partidas_modificar=response.data;
                this.$bvModal.hide("modalUploadPartidasModificaciones");
                this.$bvModal.show("modalPartidasModificaciones");
              })
              .catch((error)=>{
                if (error.response) {
                  console.log(error.response);
                  this.$swal('Error',error.response.data.message,'warning');
                }
                else
                {
                  this.$swal('Error',"Server error",'error');
                }
              })
              .finally(()=>this.isLoading=false)
        },
        abrirCargaPresupuestoModificado(){
          this.$bvModal.show("modalUploadPresupuestoModificado");
        },
        abrirCargaModificaciones(tipo_modificacion){
          this.tipo_modificacion_actual=tipo_modificacion;
          this.$bvModal.show("modalUploadPartidasModificaciones");
        },
        actualizarCostos(modificacion_tipo){
          this.isLoading=true;
          this.axios.post(process.env.VUE_APP_BACKEND +'/api/avance/modificaciones/actualizar-costos',
              {
                'modificacion_tipo':modificacion_tipo,
                'expediente_id':this.expediente_id
              }
          )
              .then(()=>{
                this.$swal('Ok','Se actualizo los costos unitarios','success');
              })
              .catch(()=>{
                this.$swal('error','Error actualizando los costos','error');
              })
              .finally(
                  ()=>
                  {
                    this.isLoadingModal=false;
                    this.actualizar();
                  }
              );
        },
        editarModificacionPartida(id){
          this.isLoading=true;
          this.axios.get(process.env.VUE_APP_BACKEND +"/api/avance/modificaciones/"+id)
              .then((response) => {
                this.partida_modificar=response.data;
                this.actualizarControles(this.partida_modificar.tipo_costo,this.partida_modificar.costo_unitario)
                this.$bvModal.show("modalPartidas");
              })
              .catch(()=>{
                this.$swal('Cuidado',"Error cargando las partidas",'warning');
              })
              .finally(()=>this.isLoading=false)
        },
        editarPartidaNueva(id){
          this.isLoading=true;
          this.axios.get(process.env.VUE_APP_BACKEND +"/api/avance/modificaciones/"+id)
              .then((response) => {
                this.nueva_partida=response.data;
                this.$bvModal.show("modalNuevasPartidas");
              })
              .catch(()=>{
                this.$swal('Cuidado',"Error cargando las partidas",'warning');
              })
              .finally(()=>this.isLoading=false)
        },
        agregarNuevasPartidasForm(){
          this.nueva_partida.id=0;
          this.partida={};
          this.nueva_partida={
                id:0,
                tipo:'P',
                tipo_costo:'Costo directo',
                codigo_partida:'',
                partida:'',
                unidad_medida:'',
                costo_unitario:'',
                cantidad:'',
                subtotal:'',
                fecha:''
          };
          /*this.nueva_partida.codigo_partida="";
          this.nueva_partida.partida="";
          this.nueva_partida.cantidad="";
          this.nueva_partida.unidad_medida="";
          this.nueva_partida.costo_unitario="";
          this.nueva_partida.subtotal="";*/
          this.$bvModal.show("modalNuevasPartidas");

        },

        cambiarMes(date){
          this.fecha_mes.mes=date.monthIndex;
          this.fecha_mes.anio=date.year;
          ///
          var fec = new Date(date.year, date.monthIndex-1, 1);
          var fec_str=fec.toISOString().substring(0,10);
          this.partida_modificar.fecha=fec_str;
          this.nueva_partida.fecha=fec_str;
          this.actualizar();
        },
        agregarValorizacionNuevasPartidasForm(){

          this.partida_modificar.id=0;
          this.titulo_modal="Avance nuevas partidas"
          this.partida_modificar.costo_unitario="";
          this.partida_modificar.cantidad="";
          this.partida_modificar.subtotal="";
          this.partida_modificar.tipo_modificacion="5";//Valorizacion nuevas partidas
          this.partida={};
          this.$bvModal.show("modalPartidas");
        },
        definicionMayoresMetradosForm(){
          this.partida={};
          this.partida_modificar.id=0;
          this.partida_modificar.costo_unitario="";
          this.partida_modificar.cantidad="";
          this.partida_modificar.subtotal="";
          this.titulo_modal="Definición mayores metrados"
          this.partida_modificar.tipo_modificacion="3";//MAYORES METRADOS
          this.$bvModal.show("modalPartidas");
        },
        agregarModificacionCostoUnitarioForm(){
          this.partida={};
          this.partida_modificar.id=0;
          this.partida_modificar.costo_unitario="";
          this.partida_modificar.cantidad="";
          this.partida_modificar.subtotal="";
          this.titulo_modal="Modificación de Costo unitario"
          this.partida_modificar.tipo_modificacion="6";//MAYORES METRADOS
          this.$bvModal.show("modalPartidas");
        },
        agregarMayoresMetradosForm(){
          this.partida={};
          this.partida_modificar.id=0;
          this.partida_modificar.costo_unitario="";
          this.partida_modificar.cantidad="";
          this.partida_modificar.subtotal="";
          this.titulo_modal="Avance Mayores metrados"
          this.partida_modificar.tipo_modificacion="2";//MAYORES METRADOS
          this.$bvModal.show("modalPartidas");
        },
        agregarDeductivosForm(){
          this.partida={};
          this.titulo_modal="Deductivos"
          this.partida_modificar.id=0;
          this.partida_modificar.costo_unitario="";
          this.partida_modificar.cantidad="";
          this.partida_modificar.subtotal="";
          this.partida_modificar.tipo_modificacion="4";//MAYORES METRADOS
          this.$bvModal.show("modalPartidas");
        },
        agregarModificarPartidaSubmit(){
          this.submittedModificarPartida = true;
          this.$v.$touch();
          if(this.$v.partida_modificar.$error==false){
            this.agregarPartidaModificada();
          }

        },
        agregarPartidaModificada(){
          this.isLoadingModal=true;
          if(this.partida_modificar.id==0){//partida nueva
            this.partida_modificar.expediente_id=this.expediente_id;
            this.partida_modificar.partida=this.partida;
            this.axios.post(process.env.VUE_APP_BACKEND +'/api/avance/modificaciones/agregar-modificacion-partida',
                this.partida_modificar
            )
                .then(()=>{
                  this.$bvModal.hide("modalPartidas");
                })
                .catch(()=>{
                  this.$swal('error','Error agregando','error');
                })
                .finally(
                    ()=>
                    {
                      this.isLoadingModal=false;
                      this.actualizar();
                    }
                );
          }
          else { //partida existente
            this.axios.put(process.env.VUE_APP_BACKEND +'/api/avance/modificaciones/'+this.partida_modificar.id,
                this.partida_modificar
            )
                .then(()=>{
                  this.$bvModal.hide("modalPartidas");
                })
                .catch(()=>{
                  this.$swal('error','Error modificando','error');
                })
                .finally(
                    ()=>
                    {
                      this.isLoadingModal=false;
                      this.actualizar();
                    }
                );
          }




        },
        filtroGlobal(tipo_modificacion){
          var res=[];
          for(var i=0;i<this.registros.length;i++){
            if(parseInt(this.registros[i].tipo_modificacion)==tipo_modificacion){ //
              res.push(this.registros[i]);
            }
          }
          return res;
        },

        cargarPartidas(){
          this.isLoading=true;
          this.axios.get(process.env.VUE_APP_BACKEND +"/api/expediente/partidas/"+this.expediente_id)
              .then((response) => {
                this.partidas= response.data.partidas;
              })
              .catch(()=>{
                this.$swal('Cuidado',"Error cargando las partidas",'warning');
              })
              .finally(()=>this.isLoading=false)
        },

        cargarPartidasNuevas(){
          this.isLoading=true;
          this.axios.get(process.env.VUE_APP_BACKEND +"/api/expediente/partidas-nuevas/"+this.expediente_id)
              .then((response) => {
                this.partidas_nuevas= response.data.partidas;
              })
              .catch(()=>{
                this.$swal('Cuidado',"Error cargando las partidas",'warning');
              })
              .finally(()=>this.isLoading=false)
        },
        calcularSubtotal(){
          if(this.nueva_partida.tipo_costo=="Costo directo"){
            this.nueva_partida.subtotal=Math.round(this.nueva_partida.costo_unitario*this.nueva_partida.cantidad*100)/100;
          }
        },
        calcularSubtotalPartidaModificada(){
          if(this.partida_modificar.id==0){
            if(this.partida.tipo_costo=="Costo directo"){
              this.partida_modificar.subtotal=Math.round(this.partida_modificar.costo_unitario*this.partida_modificar.cantidad*100)/100;
            }
          }
          else
          {
            if(this.partida_modificar.tipo_costo=="Costo directo"){
              this.partida_modificar.subtotal=Math.round(this.partida_modificar.costo_unitario*this.partida_modificar.cantidad*100)/100;
            }
          }

        },
        cambiarTipo(){
          if(this.nueva_partida.tipo=="P" && this.nueva_partida.tipo_costo=="Costo directo"){
            this.nueva_partida.costo_unitario='';
            this.nueva_partida.cantidad='';
            this.nueva_partida.unidad_medida='';
            this.disable_nueva_partida_um=false;
            this.disable_nueva_partida_costo_unitario=false;
            this.disable_nueva_partida_cantidad=false;
            this.disable_nueva_partida_subtotal=true;
          }

          if(this.nueva_partida.tipo=="P" && this.nueva_partida.tipo_costo=="Costo indirecto"){
            this.nueva_partida.unidad_medida='-';
            this.nueva_partida.costo_unitario='0';
            this.nueva_partida.cantidad='0';
            this.nueva_partida.subtotal='';

            this.disable_nueva_partida_um=true;
            this.disable_nueva_partida_costo_unitario=true;
            this.disable_nueva_partida_cantidad=true;
            this.disable_nueva_partida_subtotal=false;
          }

          if(this.nueva_partida.tipo=="T" && this.nueva_partida.tipo_costo=="Costo directo"){
            this.nueva_partida.unidad_medida='-';
            this.nueva_partida.costo_unitario='0';
            this.nueva_partida.cantidad='0';
            this.nueva_partida.subtotal='0';

            this.disable_nueva_partida_um=true;
            this.disable_nueva_partida_costo_unitario=true;
            this.disable_nueva_partida_cantidad=true;
            this.disable_nueva_partida_subtotal=true;
          }
          if(this.nueva_partida.tipo=="T" && this.nueva_partida.tipo_costo=="Costo indirecto"){
            this.nueva_partida.tipo_costo="Costo directo";
          }
        },
        agregarNuevaPartidaSubmit(){
          this.submittedNuevaPartida = true;
          // stop here if form is invalid
          this.$v.$touch();
          console.log(this.$v);
          if(this.$v.nueva_partida.$error==false){
            this.agregarNuevaPartida();
          }
        },
        agregarNuevaPartida(){
          this.isLoadingModal = true;
          this.nueva_partida.expediente_id = this.expediente_id;
          const url = this.nueva_partida.id === 0
              ? '/api/avance/modificaciones/agregar-partida'
              : '/api/avance/modificaciones/' + this.nueva_partida.id;

          const requestMethod = this.nueva_partida.id === 0 ? this.axios.post : this.axios.put;
          requestMethod(process.env.VUE_APP_BACKEND + url, this.nueva_partida)
              .then(() => {
                this.$bvModal.hide("modalNuevasPartidas");
              })
              .catch(() => {
                this.$swal('error','Error agregando ó modificando','error');
              })
              .finally(() => {
                this.isLoadingModal = false;
                this.actualizar();
              });

        },
        actualizar(){
          this.rowData=[];
          this.modificacion_id=null;
          if(this.expediente_id ==null){
            return;
          }
          if(this.fecha_mes ==null){
            this.$swal('Cuidado','Seleccione el mes','warning');
            return;
          }

          this.isLoading=true;
          this.axios.get(process.env.VUE_APP_BACKEND + '/api/avance/modificaciones/data-por-mes',{
            params:{
              expediente_id:this.expediente_id,
              fecha_mes:this.fecha_mes
            }
          })
            .then( (response)=>
            {

              this.registros=response.data;
              this.cargarPartidas();
              this.cargarPartidasNuevas();
            }).finally(()=>this.isLoading=false);
            this.axios.get(process.env.VUE_APP_BACKEND + '/api/expedientes/modificaciones/lista/'+this.expediente_id)
                .then((response)=>{
                  this.modificaciones=response.data;
            });
        },

        borrarPartida(id){
          this.$swal.fire({
            title: '¿Esta seguro de borrar la partida nueva?',
            text: "No se puede revertir esta accion!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Si, borralo!'
          }).then((result) => {
            if (result.value) {
              this.isLoading=true;
              this.axios.delete(process.env.VUE_APP_BACKEND +'/api/avance/modificaciones/borrar-partida/'+id)
                  .catch((error)=>{
                    this.$swal('error',error.response.data.mensaje,'error');
                  })
                  .finally(
                      ()=>
                      {
                        this.isLoading=false;
                        this.actualizar();
                      }

                  );
            }
          })
        },
        borrarTodasLasPartidas(tipo_modificacion){
          this.$swal.fire({
            title: '¿Esta seguro de borrar todas las partidas?',
            text: "No se puede revertir esta accion!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Si, borralo!'
          }).then((result) => {
            if (result.value) {
              this.isLoading=true;
              this.axios.delete(process.env.VUE_APP_BACKEND +'/api/avance/modificaciones/borrar-todas-partidas/',{
                'params':{
                  expediente_id:this.expediente_id,
                  tipo_modificacion:tipo_modificacion
                }
              })
                  .catch((error)=>{

                    this.$swal('error',error.response.data.mensaje,'error');
                  })
                  .finally(
                      ()=>
                      {
                        this.isLoading=false;
                        this.actualizar();
                      }

                  );
            }
          })
        }
      },
  mounted() {
      this.$cargarExpedientes((res)=>{
        this.expedientes=res.data;
        if(this.expedientes.length>0){
          this.expediente_id=this.expedientes[0].expediente_id;
          this.actualizar();
        }
      })

  },
  validations: {
    nueva_partida:{
      tipo:{required},
      codigo_partida:{required},
      partida:{required},
      unidad_medida:{required},
      costo_unitario:{required,decimal},
      cantidad:{required,decimal},
      subtotal:{required,decimal},
      fecha:{required}
    },
    partida_modificar:{
      costo_unitario:{required,decimal},
      cantidad:{required,decimal},
      subtotal:{required,decimal},
      fecha:{required}
    }

  },
}
</script>

<style scoped>
.border-11{
  border: 1px solid #b0b0b0;
}
.table-condensed{
  font-size: 12px;
}

</style>
